import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import api from './plugins/api';

library.add(fas);

createApp(App)
  .use(router)
  .use(store)
  .use(api)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app');
